<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/gateway/sendRecord/page" ref="yt" getKey="rows" :columns="columns" @afterGet="afterGet" @selectionChange="selectionChange">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchanongdanhao')">
            <el-input v-model="yt.conditions.no" size="mini" />
          </el-form-item>
          <el-form-item :label="$t('下发设备')">
            <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"></yi_data_select>
          </el-form-item>
          <el-button @click="yt.get(1)" type="primary" plain size="mini">
            {{ $t('sousuo') }}
          </el-button>
          <el-button @click="yt.clear()" size="mini">{{ $t('chongzhi') }}</el-button>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="scope.row.issuedStatus == '3' || scope.row.issuedStatus == '4'" @click="reIssued(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '网关下发记录-重新下发' } }">
              {{ $t('重新下发') }}

            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: 'cms_issued_log_index',
  data() {
    return {
      columns: [
        {
          label: 'shengchanongdanhao',
          prop: 'plan.no'
        },
        {
          label: '下发设备',
          prop: 'equipment.name'
        },
        {
          label: 'shebeiSN',
          prop: 'equipment.sn'
        },
        {
          label: '下发时间',
          prop: 'issuedTime',
          type: 'time'
        },
        {
          label: '下发类型',
          prop: 'issuedType',
          type: 'tag',
          tags: {
            '1': {
              color: '#419FFF',
              text: this.$t('工单下发')
            },
            '2': {
              color: '#67C23A',
              text: this.$t('工单归档')
            }
          }
        },
        {
          label: '下发状态',
          prop: 'issuedStatus',
          type: 'tag',
          tags: {
            '1': {
              color: '#419FFF',
              text: this.$t('下发中')
            },
            '2': {
              color: '#67C23A',
              text: this.$t('下发成功')
            },
            '3': {
              color: '#F56C6C',
              text: this.$t('下发失败')
            },
            '4': {
              color: '#F56C6C',
              text: this.$t('下发超时')
            }
          }
        },
        {
          label: '回调时间',
          prop: 'callBackTime',
          type: 'time'
        },
        {
          label: '回调状态',
          prop: 'callbackStatus',
          type: 'tag',
          tags: {
            '1': {
              color: '#419FFF',
              text: this.$t('未回调')
            },
            '2': {
              color: '#F56C6C',
              text: this.$t('已回调')
            }
          }
        },
        {
          label: 'caozuo',
          type: 'slot'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.orderBy = 'issuedTime desc';
      this.yt.get(1);
    }, 100);
  },
  methods: {
    reIssued(row) {
      this.http.get('/web/gateway/sendRecord/againIssued', { params: { id: row.id } }).then(res => {
        this.$message.success(this.$t('操作成功'));
        this.yt.get(1);
      });
    }
  }
};
</script>
